import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const ItemRateMaster = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [partyMasterId, setPartyMasterId] = useState("")
    const [partyMasterName, setPartyMasterName] = useState("")

    let initial = {
        pname: "",
        pcode: null,
        pname_short_code: '',
        agr_code_old: '',
        agr_no_old: '',
        item_status_agr: '',
        item_code: null,
        item_short_name: '',
        item_name: '',
        item_group_code: null,
        item_group_name: '',
        mix_item_yes_no: '',
        item_loc: '',
        rent_rate: '',
        broken_chg: '',
        agr_qty: '',
        agr_date: null,
        opening_qty: '',
        rate_on_type: '',
        missing_rate: '',
        notaxrate: null,
        s_no: null,
        rate_of_one_pcs: "pc",
        weight_of_one_pcs: null,

        price_sell_rate: null,
        price_sell_discount_percentage: null,
        price_sell_discount_amount: null,
        price_sell_amount_after_discount: null,
        price_sell_gst_percentage: null,
        price_sell_gst_amount: null,
        price_sell_amount_with_gst: null,
    }

    const [itemRateData, setItemRateData] = useState(initial)
    const [itemRateTable, setItemRateTable] = useState([])
    const [itemTable, setItemTable] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    // const [selectedOption, setSelectedOption] = useState('');
    const [aggreement, setAggreement] = useState(false)
    const dropdownRef = useRef(null);

    const [editMode, setEditMode] = useState(false)



    // const onHandleBackParty = () => {
    //     navigate(-1);
    // };

    const onChangeHandle = (e) => {

        const { name, value } = e.target
        setItemRateData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    // const handleAddCondition = () => {
    //     // setItemRateTable(prevConditions => [...prevConditions, itemRateData]);
    //     setSearchKey("")
    //     setItemRateData(initial)
    // }

    const AddItemRateDetail = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(`api/PartyItemRateMaster/create`, itemRateData, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                setSearchKey("")
                setItemRateData(initial)
                GetItemRateDetail(partyMasterId)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
             toast.error(`SomeThing went wrong!!`);
        }
    }

    const UpdateItemRateDetail = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(`api/PartyItemRateMaster/update`, itemRateData, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                setSearchKey("")
                setItemRateData(initial)
                GetItemRateDetail(partyMasterId)
                setEditMode(false)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
             toast.error(`SomeThing went wrong!!`);
        }
    }


    const GetItemRateDetail = async (partyId) => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/PartyItemRateMaster/itemRateByPartyMasterId?partyMasterId=${partyId}`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {

                setItemRateTable(response.partyItemRateTransData)
                if (response.partyItemRateTransData.length !== 0) {
                    setAggreement(true)
                }

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
             toast.error(`SomeThing went wrong!!`);
        }
    }

    const getItemData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/ItemMaster/allitem?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                setItemTable(response.itemMasterDetailData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
             toast.error(`SomeThing went wrong!!`);
        }
    };

    console.log(location.state)

    useEffect(() => {
        if (location.state) {
            setPartyMasterId(location.state.partyId)
            setPartyMasterName(location.state.partyName)
            GetItemRateDetail(location.state.partyId)
        }
        // GetItemRateDetail(props.partyId)

        getItemData(1, 10, "")
        setPartyMasterId(props.partyId)
        setPartyMasterName(props.partyName)
    }, [location.state])

    useEffect(() => {
        if (props.partyId) {

            GetItemRateDetail(props.partyId)
        }
    }, [location.state])


    const onHandleBackItem = () => {
        navigate(-1)
    }


    const handleOptionSelect = async (event, value) => {

        if (value === null || value === undefined) {
            setItemRateData(initial)
            return;
        }

        let findData = itemTable.find((data) => data.id === value.id)
        await setItemRateData((prevData) => ({
            ...prevData,
            pname: partyMasterName,
            pcode: partyMasterId,
            party_master_id: partyMasterId,
            item_short_name: findData?.item_short_name,
            item_name: findData?.item_name,
            agr_date: new Date(),
            item_code: findData.id,
            group: findData.group,

            price_sell_rate: findData.price_sell_rate,
            price_sell_discount_percentage: findData.price_sell_discount_percentage,
            price_sell_discount_amount: findData.price_sell_discount_amount,
            price_sell_amount_after_discount: findData.price_sell_amount_after_discount,
            price_sell_gst_percentage: findData.price_sell_gst_percentage,
            price_sell_gst_amount: findData.price_sell_gst_amount,
            price_sell_amount_with_gst: findData.price_sell_amount_with_gst,

            // notaxrate: findData?.tax_per?findData?.tax_per : null,
            // item_group_name: findData?.group,
            // weight_of_one_pcs: findData?.price_avg_weight_per_pcs?findData?.price_avg_weight_per_pcs :  null,
            // rate_of_one_pcs: "pc",
            // item_code: findData?.id?findData?.id: null,
            // agr_qty: 0,
            // rent_rate: 0,
            // missing_rate: 0,
            // broken_chg: 0,
            // opening_qty: findData?.price_opening_stock_rate
        }));
    };


    const onHandleDeleteItem = async (id) => {
        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`api/PartyItemRateMaster/delete?aggrementId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    toast.error(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    GetItemRateDetail(partyMasterId)
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                 toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    };

    const onHandleEditItem = async (id) => {

        let findArray = itemRateTable.find((data) => data.id === id)
        setItemRateData(findArray)
        setEditMode(true)
    };

    // calculation in sell detail  
    useEffect(() => {

        let sellRate = parseFloat(itemRateData.price_sell_rate || 0);
        let discountPercentage = parseFloat(itemRateData.price_sell_discount_percentage || 0);
        let discountAmount = (sellRate * discountPercentage) / 100;

        let finalAmountAfterDiscount = (parseFloat(sellRate) - parseFloat(discountAmount))

        // gst percentage
        let gstPercentage = parseFloat(itemRateData.price_sell_gst_percentage || 0)
        let gstAmount = finalAmountAfterDiscount * (gstPercentage / 100)

        const salePriceApprox = (finalAmountAfterDiscount + parseFloat(gstAmount || 0));
        setItemRateData((prevState) => ({
            ...prevState,
            price_sell_discount_amount: discountAmount,
            price_sell_amount_after_discount: finalAmountAfterDiscount,
            price_sell_gst_amount: gstAmount,
            price_sell_amount_with_gst: salePriceApprox
        }));

    }, [
        itemRateData.price_sell_rate, itemRateData.price_sell_discount_percentage,
        itemRateData.price_sell_gst_percentage
    ])

    return (

        <Row>
            <Col>
                <Card className='card-box height-100-p pd-20 mb-20'>


                    <>
                        <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-bell mr-2"></i>
                                Item Rate Detail ( { partyMasterName} )
                             </div>
                            <Button color="warning" size="bg" onClick={() => { props.backButton() }} className="ms-auto">
                                Back
                            </Button>
                        </CardTitle>

                        <CardBody>
                            <Form>
                                <Row>
                                    <Col xl={8}>
                                        <FormGroup>
                                            <Label for="short_name" style={{ fontSize: 15 }}>Item Full Name</Label>
                                            {/* <Autocomplete className="custom-border"
                                                size='small'
                                                id="item_name"
                                                name="item_name"
                                                options={itemTable.map((option) => option.item_name)} // Assuming you have defined `top100Films` somewhere in your code
                                                renderInput={(params) => <TextField {...params} />}
                                                value={itemRateData.item_name || ''}
                                                onChange={handleOptionSelect}
                                            /> */}


                                            <Autocomplete className="custom-border"

                                                size='small'
                                                id="item_name"
                                                name="item_name"
                                                options={itemTable.map((option) => ({ id: option.id, label: option.item_name }))}
                                                renderInput={(params) => <TextField {...params} />}
                                                value={itemRateData.item_name || ''}
                                                onChange={handleOptionSelect}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xl={4}>
                                        <FormGroup>
                                            <Label for="group" style={{ fontSize: 15 }}>Group Name</Label>
                                            <Input  className="custom-border"
                                                id="group"
                                                name="group"
                                                value={itemRateData.group || ""}
                                                onChange={onChangeHandle}
                                                type="text"
                                            // disabled={true}
                                            />
                                        </FormGroup>
                                    </Col>



                                </Row>


                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="price_sell_rate" style={{ fontSize: 15 }}>Sell Rate</Label>
                                            <Input  className="custom-border"
                                                id="price_sell_rate"
                                                name="price_sell_rate"
                                                value={itemRateData.price_sell_rate || ""}
                                                onChange={onChangeHandle}
                                                type="text"
                                            // disabled={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label for="price_sell_discount_percentage" style={{ fontSize: 15 }}>Disc. %</Label>
                                            <Input  className="custom-border"
                                                id="price_sell_discount_percentage"
                                                name="price_sell_discount_percentage"
                                                value={itemRateData.price_sell_discount_percentage || ""}
                                                onChange={onChangeHandle}
                                                type="text"
                                            />


                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label for="price_sell_discount_amount " style={{ fontSize: 15 }}>Disc. Amt.</Label>
                                            <Input  className="custom-border"
                                                id="price_sell_discount_amount"
                                                name="price_sell_discount_amount"
                                                value={itemRateData.price_sell_discount_amount?.toFixed(2) || ""}
                                                onChange={onChangeHandle}
                                                type="tel"
                                            // disabled={true}

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label for="price_sell_amount_after_discount" style={{ fontSize: 15 }}>Disc Rate</Label>
                                            <Input  className="custom-border"
                                                id="price_sell_amount_after_discount"
                                                name="price_sell_amount_after_discount"
                                                value={itemRateData.price_sell_amount_after_discount?.toFixed(2) || ""}
                                                onChange={onChangeHandle}
                                                type="text"
                                            // disabled={true}

                                            />
                                        </FormGroup>
                                    </Col>


                                    <Col>
                                        <Label for="price_sell_gst_percentage" style={{ fontSize: 15 }}>GST %</Label>
                                        <Input  className="custom-border"
                                            id="price_sell_gst_percentage"
                                            name="price_sell_gst_percentage"
                                            value={itemRateData.price_sell_gst_percentage || ""}
                                            onChange={onChangeHandle}
                                            type="text"
                                        // disabled={true}

                                        />
                                    </Col>

                                    <Col>
                                        <FormGroup>
                                            <Label for="price_sell_gst_amount" style={{ fontSize: 15 }}>GST Amt</Label>
                                            <Input  className="custom-border"
                                                id="price_sell_gst_amount"
                                                name="price_sell_gst_amount"
                                                value={itemRateData.price_sell_gst_amount?.toFixed(2) || ""}
                                                onChange={onChangeHandle}
                                                type="text"
                                            // disabled={true}

                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col>
                                        <FormGroup>
                                            <Label for="price_sell_amount_with_gst" style={{ fontSize: 15 }}>Final Amt</Label>
                                            <Input  className="custom-border"
                                                id="price_sell_amount_with_gst"
                                                name="price_sell_amount_with_gst"
                                                value={itemRateData.price_sell_amount_with_gst?.toFixed(2) || ""}
                                                onChange={onChangeHandle}
                                                type="text"
                                            // disabled={true}

                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>

                        {
                            editMode ?
                                <Button color="primary" size="bg" onClick={UpdateItemRateDetail} className="ms"
                                    disabled={!itemRateData.item_name}
                                >
                                    Edit Item Rate Detail
                                </Button>
                                :
                                <Button color="primary" size="bg" onClick={AddItemRateDetail} className="ms"
                                    disabled={!itemRateData.item_name}
                                >
                                    Add Item Rate Detail
                                </Button>

                        }

                    </>



                    <div>
                        <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-card-text mr-2"></i>
                                Item Rate List Detail
                            </div>
                        </CardTitle>

                        <CardBody className="">
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: 14 }}>id</th>
                                        <th style={{ fontSize: 14 }}>SName</th>
                                        <th style={{ fontSize: 14 }}>IName</th>
                                        <th style={{ fontSize: 14 }}>Sell Rate</th>
                                        <th style={{ fontSize: 14 }}>Discount %</th>
                                        <th style={{ fontSize: 14 }}>Discount Amount</th>
                                        <th style={{ fontSize: 14 }}>Amt after Dis.</th>
                                        <th style={{ fontSize: 14 }}>GST %</th>
                                        <th style={{ fontSize: 14 }}>GST Amount</th>
                                        <th style={{ fontSize: 14 }}>Amt With Gst</th>
                                        <th style={{ fontSize: 14 }}>Edit</th>
                                        <th style={{ fontSize: 14 }}>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemRateTable.map((item, index) => (
                                        <tr key={index}>
                                            <th scope="row">{index + 1}</th>
                                            <td style={{ fontSize: 15 }}>{item.item_short_name}</td>
                                            <td style={{ fontSize: 15 }}>{item.item_name}</td>
                                            <td style={{ fontSize: 15 }}>{item.price_sell_rate}</td>
                                            <td style={{ fontSize: 15 }}>{item.price_sell_discount_percentage}</td>
                                            <td style={{ fontSize: 15 }}>{item.price_sell_discount_amount?.toFixed(2)}</td>
                                            <td style={{ fontSize: 15 }}>{item.price_sell_amount_after_discount?.toFixed(2)}</td>
                                            <td style={{ fontSize: 15 }}>{item.price_sell_gst_percentage}</td>

                                            <td style={{ fontSize: 15 }}>{item.price_sell_gst_amount?.toFixed(2)}</td>
                                            <td style={{ fontSize: 15 }}>{item.price_sell_amount_with_gst?.toFixed(2)}</td>

                                            <td style={{ fontSize: 15 }}>{<Button color="success" size="bg" onClick={() => onHandleEditItem(item.id)}>
                                                Edit
                                            </Button>}
                                            </td>
                                            <td style={{ fontSize: 15 }}>{<Button color="danger" size="bg" onClick={() => onHandleDeleteItem(item.id)}>
                                                Delete
                                            </Button>}
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </div>
                </Card>
            </Col>
        </Row>
    )
}

export default ItemRateMaster